module.exports = __webpack_public_path__ + "37bb1e0905f469cec7f43a7b5ce5ea5d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/wheels-cat.png
 ** module id = 598
 ** module chunks = 0
 **/